import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupView',
  props: {
  nobutton: {
    type: Boolean,
    default: false,
  },
  width: {
    type: String,
    default: "max-w-lg",
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;

const active = ref(true);


const close = () => {
  active.value = false;
  emit("close", false);
};

// eslint-disable-next-line no-undef


return { __sfc: true,active, emit, close, props }
}

})